export interface ICandidateResponse {
  id: string;
  questionId: string;
  questionOptionId?: string;
  answer?: string;
  path?: string;
  contentType: string;
}

export class CandidateResponse {
  public id: string;
  public questionId: string;
  public questionOptionId?: string;
  public answer?: string;
  public path?: string;
  public contentType: string;

  constructor(data: ICandidateResponse) {
    this.id = data.id;
    this.questionId = data.questionId;
    this.questionOptionId = data.questionOptionId;
    this.answer = data.answer;
    this.path = data.path;
    this.contentType = data.contentType;
  }
}
